import { Navigate, useLocation } from "react-router-dom";
import { loginPath, resolveLang } from "../../utils/navigation";

/** Unknown paths → login for the URL language (avoids blank /en redirects). */
export const NotFoundRedirect = () => {
  const location = useLocation();
  const segment = location.pathname.split("/").filter(Boolean)[0];
  return <Navigate to={loginPath(resolveLang(segment))} replace />;
};
